import React from "react";
import { Outlet } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";

export default function PortalShell() {
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", bgcolor: "background.default" }}>
      <AppBar position="sticky" elevation={0}>
        <Toolbar>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                width: 34,
                height: 34,
                borderRadius: 1.5,
                display: "grid",
                placeItems: "center",
                bgcolor: "primary.main",
                color: "white",
              }}
            >
              <SwapHorizIcon fontSize="small" />
            </Box>
            <Typography variant="subtitle1" fontWeight={700}>
              Salla Returns
            </Typography>
          </Stack>
        </Toolbar>
      </AppBar>

      <Box
        component="main"
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
          py: 4,
        }}
      >
        <Outlet />
      </Box>

      <Box
        component="footer"
        sx={{
          py: 1.5,
          px: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderTop: 1,
          borderColor: "divider",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <VerifiedUserOutlinedIcon sx={{ fontSize: 14, color: "text.secondary" }} />
          <Typography variant="caption" color="text.secondary" fontWeight={700}>
            Salla Shield Protected
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
}
